<template lang="pug">
.subheader.p-3
    //- in result
    template(v-if="route_name === 'PageResult'")
        .info-result.flex.items-center.justify-between.mb-4
            figure.mr-2
                //- img.h-8.w-8(src="https://randomuser.me/api/portraits/men/9.jpg")
                img.h-8.w-8(:src="profile_subheader.photo ? profile_subheader.photo : defaultImage" @error="getDefaultImageProfile")
                    
            strong.block.flex-grow
                //- span.one-line-name {{ profile_subheader.name ? profile_subheader.name : '-' }}
                span.one-line-name(
                    v-tooltip="profile_subheader_name && profile_subheader_name.name?profile_subheader_name.name:(profile_subheader.name ? profile_subheader.name : '-')"
                )
                    Spinner(v-if=" load_data_status_profile_subheader_name.status === 'loading' || load_data_status_profile_subheader.status === 'loading'" show="true" size="30")
                    template(v-else)
                        | {{ profile_subheader_name && profile_subheader_name.name?profile_subheader_name.name:(profile_subheader.name ? profile_subheader.name : '-') }}
            //- template(v-if="profile_subheader.msisdn")
            template(v-if="Object.keys(profile_subheader).length > 0")
                //- .status.status--offline.flex.items-center(v-if="profile_subheader.state == 'unknown' || profile_subheader.state == 'switch off' || profile_subheader.aol == '-1' || (profile_subheader.aol == null && profile_subheader.state == null || profile_subheader.state == 'number no longer available in network-cause code 404')")
                //-     //- .bubble
                //-     span OFFLINE
                //- .status.status--online.flex.items-center(v-else)
                //-     //- .bubble
                //-     span ONLINE
                .status.status--online.flex.items-center(v-if="profile_subheader.state == 'idle' || profile_subheader.state == 'busy'")
                    //- .bubble
                    span ONLINE
                .status.status--offline.flex.items-center(v-else)
                    span OFFLINE
                    //- .bubble
            //- template(v-else)
                Spinner(v-if="load_data_status_profile_subheader.status === 'loading'" show="true" size="32")

        .list.flex.items-center.justify-between.mb-2
            .flex.items-center
                span Phone 
                span.info-subheader(v-tooltip="(profile_subheader.os ? '<span>'+ profile_subheader.os +'<span><br><br>'+'<span>' : '') + (profile_subheader.tagDevice && profile_subheader.tagDevice.length > 0 ? profile_subheader.tagDevice.join(', ') : '---') + '</span>'")
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
            //- strong.monospace.one-line-name {{ profile_subheader.phone ? profile_subheader.phone : '-' }}
            strong.monospace.one-line-name(
                v-tooltip="profile_subheader.phone ? profile_subheader.phone : '-'"
            )
                Spinner(v-if="load_data_status_profile_subheader.status === 'loading'" show="true" size="30")
                template(
                    v-else
                )
                    | {{ profile_subheader.phone ? profile_subheader.phone : '-' }}
        .list.flex.items-center.justify-between.mb-2
            span MSISDN
            //- strong.monospace {{ profile_subheader.msisdn ?  profile_subheader.msisdn : '-' }}
            strong.monospace
                Spinner(v-if="load_data_status_profile_subheader.status === 'loading'" show="true" size="30")
                template(v-else)
                    | {{ profile_subheader.msisdn ?  profile_subheader.msisdn : '-' }}
        .list.flex.items-center.justify-between.mb-2
            .flex.items-center
                span IMEI
                span.info-subheader(v-tooltip="'[IMEI-SV] ' + (profile_subheader.imeiSv ? profile_subheader.imeiSv : '---')")
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
            //- strong.monospace {{ profile_subheader.imei ? profile_subheader.imei : '-' }}
            strong.monospace
                Spinner(v-if="load_data_status_profile_subheader.status === 'loading'" show="true" size="30")
                template(v-else)
                    | {{ profile_subheader.imei ? profile_subheader.imei : '-' }}
        .list.flex.items-center.justify-between.mb-2
            span IMSI
            //- strong.monospace {{ profile_subheader.imsi ? profile_subheader.imsi : '-' }}
            strong.monospace
                Spinner(v-if="load_data_status_profile_subheader.status === 'loading'" show="true" size="30")
                template(v-else)
                    | {{ profile_subheader.imsi ? profile_subheader.imsi : '-' }}

        //- .flex.justify-end.w-full
            button.btn-primary-o.py-1.px-3.w-full.text-center(v-on:click="popupShow = !popupShow") SAVE AS CLUE
        .flex.justify-end.w-full
            button.btn-primary-o.btn-primary--disabled.py-1.px-3.w-full.text-center(
                v-if="load_data_status_profile_subheader.status === 'loading'"
                type='button'
                disabled="disabled" 
            ) LOADING...

            button.btn-primary-o.py-1.px-3.w-full.text-center(
                v-else-if="checkTarget(profile_subheader && profile_subheader.target_name && (profile_subheader.target_name || profile_subheader.target_name.toString().length === 0) ? profile_subheader.target_name.toString() : undefined)"
                type='button'
                v-on:click="popupShow = !popupShow"
            ) SAVE AS CLUE

            button.btn-primary-o.btn-primary--disabled.py-1.px-3.w-full.text-center(
                v-else 
                v-tooltip="'MSISDN sudah terdaftar sebagai target: '+ (profile_subheader && profile_subheader.target_name && profile_subheader.target_name.toString().length > 0 ? profile_subheader.target_name : '-')"
            ) SAVE AS CLUE
            //- disabled="disabled" 
            //- style="cursor: pointer;"

    //- in result
    template(v-if="route_name === 'PageTargetDetail'")
        .box-target-detail.block.py-4
            router-link.w-20.h-20.m-auto.block(to="/target/detail/home")
                img.rounded-full.w-full.h-full.object-cover(:src="load_data_status_single_target_detail !== 'loading' && single_target_detail.photos && single_target_detail.photos.length ? single_target_detail.photos[0].file : (single_target_detail.photo ? single_target_detail.photo : defaultImageProfile)" @error="getDefaultImageProfile")
            router-link(to="/target/detail/home").flex.items-center.justify-center.py-2
                h2.text-sm.block.link-text.mr-1(v-if="load_data_status_single_target_detail == 'loading'") loading...
                h2.text-sm.block.link-text.mr-1(v-else) {{ single_target_detail.target_name }}
                //- label.w-3.h-3.rounded-full.bg-red-500
                //- label(:class="[`bg-${single_target_detail.label}-500 w-3 h-3 rounded-full`]")
                label(v-if="load_data_status_single_target_detail !== 'loading'" :class="[`w-3 h-3 rounded-full`]" :style="'background-color: '+ single_target_detail.label +';'")

            .block.border-t.mt-2.pt-2
                .field.mb-1
                    label.block.text-xs.font-normal.text-center.mb-2(for="fieldError") Choose a MSISDN
                    .relative
                        select.field-style(v-model="selectedClues" @change="changeClues()")
                            option(v-for="data in single_target_detail.clues" v-if="data.name === 'msisdn'") {{ data.value }}
                            //- option 08123456789012
                            //- option 08123456789012
                            //- option 08123456789012
                        .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>

    //- in vehicles
    template(v-else-if="route_name === 'vehicles'")
        .list.flex.items-center.justify-between.mb-2
            span Plat Nomor
            strong.monospace {{ vehicleData!==null && vehicleData.NO_POLISI? vehicleData.NO_POLISI : '-' }}
        .list.flex.items-center.justify-between.mb-2
            span Pemilik
            strong.monospace {{ vehicleData!==null && vehicleData.PEMILIK? vehicleData.PEMILIK : '-' }}
        .list.flex.items-center.justify-between.mb-2
            span No. KTP
            strong.monospace {{ vehicleData!==null && vehicleData.NO_KTP? vehicleData.NO_KTP : '-' }}
        .flex.justify-end.mb-4.w-full
            a.btn-primary-o.py-1.px-2.w-full.text-center save as target

    //- popup new target
    section(v-bind:class="{ 'section-popup--show' : popupShow}").section-popup.fixed.w-full-h.full.bg-gray-100.inset-0.flex.items-start.justify-center
        .section-popup__container
            .box
                .box__header.no-border
                    header.flex.items-center.justify-between
                        .header-meta
                            h2.subheading Save As Clue
                        .header-cta
                            button.btn-icon.btn-icon-40(v-on:click="popupShow = !popupShow")
                                .icon-btn
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                .box__body.p-4(style="min-height:500px")
                    .flex.mb-8
                        .field.mr-2.relative.field--search.flex-grow
                            input.field-style(
                                v-model="target_keyword"
                                id="field" 
                                type="text"
                                placeholder="Search Target's name here"
                                @keyup="searchTarget()"
                            )
                            .absolute.inset-y-0.right-0.flex.items-center.px-2
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                            
                            .box-find-selected.absolute.inset-0.rounded.px-2.border(v-if="target_selected")
                                .flex.items-center.justify-between
                                    .flex.items-center
                                        label.inline-block.w-4.h-4.rounded-full.mr-2(
                                            :style="'background-color: '+ target_selected.label +';'"
                                        )
                                        figure.w-6.h-6.mr-4
                                            img.w-full.h-full.object-cover.rounded-full.bg-gray-100(:src="target_selected.photos && target_selected.photos[0] ? target_selected.photos[0].file : (target_selected.photo ? target_selected.photo : ImgAvatar)" @error="getDefaultImageProfile")
                                        span.text-light.name-index {{ target_selected.target_name }}
                                        //- figure.mr-3
                                        //-     img.w-full.h-full.object-cover.rounded-full.bg-gray-100(:src="target_selected.photos && target_selected.photos[0] ? target_selected.photos[0].file : (target_selected.photo ? target_selected.photo : ImgAvatar)" @error="getDefaultImageProfile")
                                        //- span {{target_selected.target_name}}
                                        //- label.inline-block.w-4.h-4.rounded-full(
                                            :style="'background-color: '+ target_selected.label +';'"
                                        //- )
                                    //- div.label
                                    button.btn-icon-24(@click="setEmptyTarget" v-tooltip="'Remove user'")
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>

                    .flex.items-center.w-full.mb-4.mt-4.justify-center(v-if="load_data_status_single_target_list.status === 'loading' && next_page === false")
                        .flex.flex-wrap.items-center.justify-center
                            Spinner(show="true" size="48")
                    .block.border-b.mb-4.pb-4(v-else-if="single_target_list_data.length > 0")
                        strong.block.text-xs.uppercase.mb-4 Choose a Target
                        .target-lists.block
                            ul
                                li.flex.items-center.justify-between.border-b.border-gray-200.p-4(
                                    class="hover:bg-gray-100"
                                    v-for="(target,index) in single_target_list_data"
                                    :key="index"
                                    @click="selectTarget(target)"
                                    style="cursor: pointer;"
                                    v-tooltip="'Choose this target'"
                                )
                                    div.flex.items-center
                                        figure.w-6.h-6.mr-4
                                            img.w-full.h-full.object-cover.rounded-full.bg-gray-100(:src="target.photos && target.photos[0] ? target.photos[0].file : (target.photo ? target.photo : ImgAvatar)" @error="getDefaultImageProfile")
                                        span.text-light.name-index {{ target.target_name }}
                                    div.label
                                        label.inline-block.w-4.h-4.rounded-full(
                                            :style="'background-color: '+ target.label +';'"
                                        )
                                //- li.flex.items-center.justify-between.border-b.border-gray-200.p-4(class="hover:bg-gray-100")
                                    div.flex.items-center
                                        figure.w-6.h-6.mr-4
                                            img.w-full.h-full.object-cover.rounded-full.bg-gray-100(src="https://randomuser.me/api/portraits/women/50.jpg")
                                        span.text-light.name-index agilbaka
                                    div.label
                                        label.inline-block.bg-red-500.w-4.h-4.rounded-full
                    .flex.items-center.w-full.mb-8.mt-2.justify-center(v-else-if="single_target_list.data && single_target_list.data.length == 0")
                        span.text-md
                            | No data available.
                    //- .flex.items-center.justify-between
                    .flex.mb-4
                        button.btn.btn-primary.btn-large.w-full(
                            :class="target_selected?'':'btn-primary--disabled'"
                            type='submit'
                            :disabled="target_selected?false:'disabled'"
                            @click='updateTarget()'
                        ) Save As Clue
                    
                    .flex.mb-8
                        button.btn.btn-primary-o.btn-large.w-full(
                            type='submit'
                            @click='createTarget()'
                        ) Save As New Target

</template>

<script>
import { mapState } from 'vuex';
import Spinner from '@/components/Spinner.vue';
import { encrypt, decrypt } from '@/util/crypto';

export default {
    name: 'SidebarHeader',
    components: {
        Spinner,
    },
    data: function() {
        return {
            popupShow: false,
            // defaultImage: this.$store.getters.getDefaultImage,
            defaultImage: require('../../../assets/images/default-phone.png'),
            defaultImageProfile: require('../../../assets/no-image-profile.jpg'),
            selectedClues: null,
            target_keyword: '',
            target_selected: null,
            photosFile: [],
            // pagination for target list
            single_target_list_data: [],
            page: 1,
            total_page: null,
            next_page: false,
        };
    },
    props: ['route_name','isKey'],
    computed: {
        ...mapState([
            'load_data_status_profile_subheader',
            'load_data_status_profile_subheader_name',
            'load_data_status_single_target_detail',
            'profile_subheader',
            'profile_subheader_name',
            'single_target_detail',
            'vehicles',
            'single_target_list',
            'load_data_status_single_target_list',
        ]),
        vehicleData() {
            return (this.isKey && Object.keys(this.vehicles).length > 0) ? this.vehicles[0] : null;
        },
    },
    watch: {
        // route_name() {},
        // isKey() {},
        vehicleData() {},
        popupShow(newData){
            if(newData) {
                this.searchTarget();
            }
        },
        single_target_list(newData) {
            if (newData.data && newData.data.length > 0) {
                // console.log(newData.data.length)
                this.page = parseInt(newData.current_page);
                this.total_page = parseInt(newData.total_page);

                for (var i = 0; i < newData.data.length; i++) {
                    this.single_target_list_data.push(newData.data[i]);
                }
            } else {
                this.single_target_list_data = []
            }
        },
        target_selected(newData){
            if (newData && newData.photos && newData.photos.length > 0) {
                this.photosFile = [];
                for (let i = 0; i < newData.photos.length; i++) {
                    const url = newData.photos[i].file
                    const ext = url.split('.').pop();
                    const fileName = 'image'+i+'.'+ext
                    fetch(url)
                        .then(async response => {
                            const contentType = response.headers.get('content-type')
                            const blob = await response.blob()
                            const file = new File([blob], fileName, {
                                contentType
                            })
                            this.photosFile.push(file)
                            // access file here
                        })
                    
                }
            }
        }, 
    },
    methods: {
        createTarget(){
            var decrypt_data = this.decryptData();

            // console.log('decrypt_data')
            // console.log(decrypt_data)
            // let routeData = this.$router.resolve({
            this.$router.push({
                name: 'PageTargetCreate', 
                params: { 
                    propTarget: {
                        target_name: this.target_keyword,
                        clues: {
                            name:"msisdn",
                            value: this.profile_subheader && this.profile_subheader.msisdn? this.profile_subheader.msisdn :'',
                            detail: [
                                {
                                    name:"imsi",
                                    value:this.profile_subheader && this.profile_subheader.imsi? this.profile_subheader.imsi :''
                                },{
                                    name:"imei",
                                    value:this.profile_subheader && this.profile_subheader.imei? this.profile_subheader.imei :''
                                }
                            ],
                        },
                        decrypt_data: decrypt_data
                    }
                }
            })
            // // window.open(routeData.href, '_blank');
        
            // let routeData = this.$router.resolve({ 
            //     name: 'PageTargetCreate', 
            //     params: { 
            //         propTarget: {
            //             target_name: this.target_keyword,
            //             clues: {
            //                 name:"msisdn",
            //                 value: this.profile_subheader && this.profile_subheader.msisdn? this.profile_subheader.msisdn :'',
            //                 detail: [
            //                     {
            //                         name:"imsi",
            //                         value:this.profile_subheader && this.profile_subheader.imsi? this.profile_subheader.imsi :''
            //                     },{
            //                         name:"imei",
            //                         value:this.profile_subheader && this.profile_subheader.imei? this.profile_subheader.imei :''
            //                     }
            //                 ],
            //             }
            //         }
            //     }
            // });

            // return routeData.href;
        },
        updateTarget(){
            this.showLoading(true);

            let clues = {
                name:"msisdn",
                value: this.profile_subheader && this.profile_subheader.msisdn? this.profile_subheader.msisdn :'',
                detail: [
                    {
                        name:"imsi",
                        value:this.profile_subheader && this.profile_subheader.imsi? this.profile_subheader.imsi :''
                    },{
                        name:"imei",
                        value:this.profile_subheader && this.profile_subheader.imei? this.profile_subheader.imei :''
                    }
                ],
            }
            this.target_selected.clues.push(clues)

            // if (this.target_selected.photos && this.target_selected.photos.length > 0) {
            //     console.log('masuk photos')
            //     this.photosFile = []
            //     for (let i = 0; i < this.target_selected.photos.length; i++) {
            //         console.log(i)
            //         const url = this.target_selected.photos[i].file
            //         const ext = url.split('.').pop();
            //         const fileName = 'image'+i+'.'+ext
            //         fetch(url)
            //             .then(async response => {
            //                 const contentType = response.headers.get('content-type')
            //                 const blob = await response.blob()
            //                 const file = new File([blob], fileName, {
            //                     contentType
            //                 })
            //                 this.photosFile.push(file)
            //             })
                    
            //     }
            // }
            console.log('photosFile')
            console.log(this.photosFile)
            
            this.$store.dispatch('getSingleTargetUpdateNew', [this.target_selected.id, this.target_selected.target_name, [JSON.stringify(this.target_selected.clues)], this.target_selected.label, this.photosFile, [JSON.stringify(this.target_selected.case_id)], this.target_selected.description, [JSON.stringify(this.target_selected.additional_info)]])// this.status,
                .then((resp) => {
                    if (resp.result === 'success') {
                        this.profile_subheader.target_id = this.target_selected.id
                        this.profile_subheader.target_name = this.target_selected.target_name
                        this.$swal.fire({
                            icon: 'success',
                            title: 'Data successfully updated!',
                            timer: 3000,
                        });
                        this.popupShow = !this.popupShow
                    } else {
                        if (resp.data.message && resp.data.message.errors) {
                            this.error(resp.data.message.errors);
                        } else {
                            this.error();
                        }
                    }
                });
        
        },

        searchTarget(nextPage=false) {
            // clear timeout variable
            clearTimeout(this.timeout);

            var self = this;
            this.timeout = setTimeout(function () {
                // if (self.target_keyword.length > 2) {
                    self.$store.commit('setSingleTargetList', {});
                    if (nextPage === false) {
                        self.single_target_list_data = [];
                        self.page = 1;
                        self.total_page = null;
                        self.next_page = false;
                    } else {
                        self.next_page = true;
                    }
                    self.$store.dispatch('getSingleTargetList', [10, (nextPage === false ? self.page : (self.page + 1)), self.target_keyword]);
                // }
            }, 650);
        },
        selectTarget(target) {
            this.target_selected = target;
            this.$store.commit('setSingleTargetList', {});
        },
        setEmptyTarget(){
            this.target_selected = null;
            this.searchTarget();
        },
        getDefaultImage(e) {
            e.target.src = this.defaultImage;
        },
        getDefaultImageProfile(e) {
            e.target.src = this.defaultImageProfile;
        },
        filter() {
            var decrypt_data = this.decryptData();

            // console.log(decrypt_data)
            // console.log(this.$route.matched[0].name)

            // if (this.$route.matched[0].path === '/result') {
            if (this.$route.matched[0].name === 'PageResult' && decrypt_data !== null) {
                this.$store.dispatch('getResultData', [decrypt_data.key, decrypt_data.type]);
            }

        },
        decryptData() {
            let data = null;

            if (this.$route.params.key) {
                let decrypt_data = decrypt(this.$route.params.key);
                decrypt_data = decrypt_data.split('&&');
                // console.log(decrypt_data);

                var key = decrypt_data[0];
                var type = decrypt_data[1];

                data = { key: key, type: type };
            }
            return data;
        },
        changeClues(){
            var msisdn = this.selectedClues    
            this.$router.push({ name: 'PageTargetDetailHome', params: { id: this.$route.params.id ,key: encrypt(msisdn + '&&msisdn') }  })
        },
        checkTarget(name){
            if(name) {
                var res = name.split(" ")
                // console.log('res.length')
                // console.log(res.length)
                if(res.length > 1){
                    // if (res[0].toLowerCase() == 'target' && res[1] == this.profile_subheader.msisdn) {
                    var msisdn = (this.profile_subheader && this.profile_subheader.msisdn && this.profile_subheader.msisdn.toString().length > 0 ? this.profile_subheader.msisdn : null);
                    if (res[0].toLowerCase() == 'target' && res[1] == msisdn) {
                        return true
                    }
                    return false
                }
                return false
            } else {
                return true
            }
        },
        showLoading(show=true) {
            if (show) {
                this.$swal.fire({
                    title: '',
                    html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

            } else {
                this.$swal.close();
            }
        },
        error(data=null) {
            let errors = '';

            if (data !== null) {
                Object.keys(data).forEach(function (item) {
                    errors += data[item] + '<br><br>';
                    // errors += '<div class="swal2-html-container" style="display: block;">' + data[item] + '<div>';
                });
            }

            this.$swal.fire({
                icon: 'error',
                title: 'Failed!',
                text: 'Something wrong.',
                html: errors,
                // timer: 3000
            });
        },
    },
    mounted() {
        if (this.route_name=="PageTargetDetail") {        
            var decrypt_data = this.decryptData();
            this.selectedClues = decrypt_data.key 
            // this.filter()
        }
        // console.log('================== mounted in sidebar Subheader.vue');
        // console.log(this.load_data_status_profile_subheader);
    }
}
</script>

<style lang="sass">
.info-result
    font-size: 11px
    .status
        font-size: 9px
        font-weight: 700
        border-radius: 20px
        padding: 2px 8px
        border: 1px solid
        &--online 
            color: #47C061
            .bubble
                background-color: #47C061
        .bubble
            width: 6px
            height: 6px
            border-radius: 100%
            margin-right: 2px

.one-line-name
    text-overflow: ellipsis
    white-space: nowrap
    display: block
    overflow: hidden
    max-width: 85px

.list
    span,
    strong
        display: block
    span
        opacity: 0.8
    strong
    font-size: 14px

.info-subheader
    color: #40bb5b
    cursor: pointer
    // border-width: 0
    // border-style: solid
    // border-color: #e2e8f0
    float: right
    margin-left: 5px

.section-popup
    z-index: 1000
    transition: all 0.3s ease
    transform: translateY(150%)
    overflow: auto
    &--show
        transform: translateY(0%)
        .section-popup__container
            animation: showContainerModal 0.9s ease

    &__container
        padding-top: 80px
        width: 100%
        max-width: 600px
        // opacity: 0

@keyframes showContainerModal
    from
        transform: translateY(150px)
        opacity: 0
    to
        transform: translateY(0px)
        opacity: 1

.box-find-selected
    background-color: #1A1A1A
    padding-top: 6px
    border-color: #22272b
</style>
